import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavigationComponent } from './components/navigation/navigation.component';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from "@angular/platform-browser";
import { FooterComponent } from './components/footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { environment } from '../environments/environment';
import { SeoService } from './services/seo.service';
import { filter } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NavigationComponent, MatIconModule, FooterComponent, MatCardModule, CookieConsentComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
  ) {
    // Adding new icons
    this.matIconRegistry.addSvgIcon(
      `chevron_down`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron-down.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `minimal_arrow`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/minimal-arrow.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `heart_circle`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heart-circle.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `magic_star`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/magic-star.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `eye`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/eye.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `people`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/people.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `monitor`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/monitor.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `programming_arrow`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/programming-arrow.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `tick_circle`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/tick-circle.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `hearts`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/hearts.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `medal`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/medal.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `quote`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/quote.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `location`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/location.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `clock`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/clock.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `calendar_tick`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar-tick.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `gift`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/gift.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `medal_star`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/medal-star.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `teacher`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/teacher.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `book`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/book.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `clipboard_tick`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/clipboard_tick.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `shield_tick`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/shield-tick.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `design_tools`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/designtools.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `search_status`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/search-status.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `tick`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/tick.svg')
    );
  }

  ngOnInit() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      let route = this.activatedRoute.root;
      while (route.firstChild) route = route.firstChild;
      const seo = route.snapshot.data['seo'];
      seo ? this.seoService.update(seo) : this.seoService.reset();
    });
  }

  resetPosition() {
    if (isPlatformBrowser(this.platformId) && !this.router.url.includes('#')) {
      window.scrollTo(0, 0);
    }
  }
}
